import { Controller } from "@hotwired/stimulus"

// Filters a moments feed in the browser: by kind, adventure node (DM only),
// hidden-only (DM only) and free text. Live-appended moments are filtered too,
// via a MutationObserver. Nothing is removed from the DOM, only hidden.
export default class extends Controller {
  static targets = ["list", "kind", "node", "hiddenOnly", "search", "count", "detail"]
  static values = { nodes: Object, current: String }

  connect() {
    this.observer = new MutationObserver(() => this.apply())
    if (this.hasListTarget) this.observer.observe(this.listTarget, { childList: true })
    this.apply()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggleKind(event) {
    const button = event.currentTarget
    button.setAttribute("aria-pressed", button.getAttribute("aria-pressed") === "true" ? "false" : "true")
    this.apply()
  }

  apply() {
    if (!this.hasListTarget) return

    const kinds = new Set(this.kindTargets
      .filter((b) => b.getAttribute("aria-pressed") === "true")
      .map((b) => b.dataset.kind))
    const node = this.hasNodeTarget ? this.nodeTarget.value : ""
    const hiddenOnly = this.hasHiddenOnlyTarget && this.hiddenOnlyTarget.checked
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""

    let shown = 0
    const moments = this.listTarget.querySelectorAll("[data-moment]")
    moments.forEach((el) => {
      this.labelNode(el)
      const nodeId = el.dataset.nodeId || ""
      const visible =
        kinds.has(el.dataset.kind) &&
        (node === "" || (node === "none" ? nodeId === "" : nodeId === node)) &&
        (!hiddenOnly || el.dataset.hidden === "true") &&
        (query === "" || el.textContent.toLowerCase().includes(query))
      el.hidden = !visible
      if (visible) shown += 1
    })

    this.showDetail(node)

    if (this.hasCountTarget) {
      this.countTarget.textContent = shown === moments.length ? "" : `${shown} of ${moments.length}`
    }
  }

  // DM-only: show the runbook details for the picked node, else the node the
  // party is currently in (the latest tagged moment's).
  showDetail(picked) {
    if (!this.hasDetailTarget) return
    const wanted = /^\d+$/.test(picked) ? picked : this.currentValue
    this.detailTargets.forEach((el) => {
      const match = el.dataset.nodeId === wanted
      el.hidden = !match
      const label = el.querySelector("[data-feed-filter-label]")
      if (label) label.textContent = el.dataset.nodeId === this.currentValue ? "Where we are" : "Adventure node"
    })
  }

  // Fills the DM-only node badge from the id -> name map (DM page only, so
  // player pages never carry node names).
  labelNode(el) {
    const badge = el.querySelector("[data-node-badge]")
    if (!badge) return
    const info = this.nodesValue[el.dataset.nodeId]
    badge.textContent = info ? info.name : ""
    if (info && info.url) badge.setAttribute("href", info.url)
    badge.classList.toggle("hidden", !info)
  }
}
